export function attachProgressUI(root) {
  let overlay = root.querySelector(".lgpxp__progress");

  if (!overlay) {
    overlay = document.createElement("div");
    overlay.className = "lgpxp__progress";
    overlay.innerHTML = `
      <div class="lgpxp__progress__box">
        <div class="lgpxp__progress__label">Preparing...</div>
        <div class="lgpxp__progress__bar"><span></span></div>
        <button type="button" class="lgpxp__progress__cancel">Cancel</button>
      </div>`;
    root.appendChild(overlay);
  }

  const label = overlay.querySelector(".lgpxp__progress__label");
  const span = overlay.querySelector(".lgpxp__progress__bar > span");
  const cancelBtn = overlay.querySelector(".lgpxp__progress__cancel");

  return {
    show() {
      overlay.style.display = "flex";
    },
    hide() {
      overlay.style.display = "none";
    },
    text(text) {
      label.textContent = text;
    },
    pct(percent) {
      span.style.width = Math.max(0, Math.min(100, percent)) + "%";
    },
    onCancel(fn) {
      cancelBtn.style.display = "inline-block";
      cancelBtn.onclick = fn;
    },
    offCancel() {
      cancelBtn.style.display = "none";
      cancelBtn.onclick = null;
    },
  };
}
